import { API_BASE, authHeaders, apiDetail, parseJson } from "../api/client";

export { apiDetail };

/** @deprecated use authHeaders from api/client */
export function identityAuthHeaders() {
  return authHeaders();
}

export async function listIdentities() {
  const res = await fetch(`${API_BASE}/admin/identities`, { headers: authHeaders() });
  const data = await parseJson(res);
  return Array.isArray(data.users) ? data.users : [];
}

export async function fetchGrantCatalog() {
  const res = await fetch(`${API_BASE}/auth/grant-catalog`, { headers: authHeaders() });
  return parseJson(res);
}

export async function approveIdentity(id, payload) {
  const res = await fetch(`${API_BASE}/admin/identities/${id}/approve`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}

export async function patchIdentity(id, payload) {
  const res = await fetch(`${API_BASE}/admin/identities/${id}`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}

export async function createDashboardUser(payload) {
  const res = await fetch(`${API_BASE}/admin/dashboard-users`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}

export async function searchFoxlineEmployees(q, { unlinkedOnly = true, limit = 40 } = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("unlinked_only", unlinkedOnly ? "true" : "false");
  params.set("limit", String(limit));
  const res = await fetch(`${API_BASE}/admin/foxline-employees?${params}`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  return Array.isArray(data.employees) ? data.employees : [];
}

export async function inviteIdentity(payload) {
  const res = await fetch(`${API_BASE}/admin/identities/invite`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  return parseJson(res);
}

export async function resendInvite(identityId) {
  const res = await fetch(`${API_BASE}/admin/identities/${identityId}/resend-invite`, {
    method: "POST",
    headers: authHeaders(),
  });
  return parseJson(res);
}

export async function linkFoxline(identityId, foxlineEmployeeId) {
  const res = await fetch(`${API_BASE}/admin/identities/${identityId}/foxline`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({ foxline_employee_id: foxlineEmployeeId }),
  });
  return parseJson(res);
}

export async function unlinkFoxline(identityId) {
  const res = await fetch(`${API_BASE}/admin/identities/${identityId}/foxline`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  return parseJson(res);
}

export async function impersonateIdentity(id, product) {
  const res = await fetch(`${API_BASE}/admin/identities/${id}/impersonate`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ product }),
  });
  return parseJson(res);
}
